"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseOptionsTooltip = void 0;
var globalVars_module_scss_1 = __importDefault(require("@aon/aon-tws-common-ui/build/lib/globalVars.module.scss"));
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var React = __importStar(require("react"));
var models_1 = require("../../models");
var ResponseOptionsTooltipContent_1 = require("./ResponseOptionsTooltipContent");
var styled_components_1 = __importDefault(require("styled-components"));
var contentConstants_1 = __importDefault(require("../../contentConstants"));
var MultipleResponses = styled_components_1.default.span.attrs({
    className: 'tws-question-multiple-responses',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tfont-size: ", ";\n\tdisplay: block;\n"], ["\n\tfont-size: ", ";\n\tdisplay: block;\n"])), globalVars_module_scss_1.default.fontSizeXsmall);
MultipleResponses.displayName = 'MultipleResponses';
var ResponseOptionsTooltip = /** @class */ (function (_super) {
    __extends(ResponseOptionsTooltip, _super);
    function ResponseOptionsTooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResponseOptionsTooltip.prototype.render = function () {
        var _a = this.props, id = _a.id, questionType = _a.questionType, responseOptions = _a.responseOptions;
        var displayText = this.props.responseOptionGroup || contentConstants_1.default.EMPTY_PLACEHOLDER;
        if (!responseOptions || !responseOptions.length) {
            return displayText;
        }
        var tooltipId = id + '_' + displayText;
        return (React.createElement(React.Fragment, null,
            React.createElement("span", null, displayText),
            React.createElement(aon_tws_common_ui_1.Tooltip, { id: tooltipId, contentType: 'jsx', inverted: this.props.invertedTooltip }, (0, ResponseOptionsTooltipContent_1.ResponseOptionsTooltipContent)(displayText, responseOptions)),
            questionType === models_1.QuestionType.Checkbox && (React.createElement(MultipleResponses, null, contentConstants_1.default.RESPONSE_OPTION_GROUP_MULTIPLE_RESPONSES))));
    };
    return ResponseOptionsTooltip;
}(React.Component));
exports.ResponseOptionsTooltip = ResponseOptionsTooltip;
var templateObject_1;
